<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof13">
<p class="tit"><em class="italic">Officers of the 1st and 2nd Western Army and their Graduate Institutions, 1812</em></p>
<p class="centerImage"><img alt="image" id="imgfr7" src="images/imgfr7.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof13.vue?2956e50a